import React from "react";
import { FieldWrapper } from "../../components/FieldWrapper";
import { Width } from "../configurables";
import { ISubfields } from "../interfaces/ISubfields";
import { TableRow } from "./TableRow";

export class TimeTableRow extends TableRow implements ISubfields {
    public subfields = [];
    public label = "Uhrzeit";
    public icon = "clock-o";
    public fieldType = "Uhrzeit";

    public getConfigurables() {
        return [Width];
    }

    public toHotColumn(): {} {
        return {
            type: "time",
            correctFormat: true,
            timeFormat: "hh:mm:ss",
        };
    }

    public EditComponent({ schema, designer, field, entry = null, register }) {
        return (
            <FieldWrapper designer={designer} schema={schema} field={field}>
                <label>Überschrift</label>
                <input
                    type={field.designerInputType}
                    name={field.inputName("label")}
                    className="form-control"
                    defaultValue={field.label}
                    ref={register}
                />
            </FieldWrapper>
        );
    }
}
